if (!customElements.get('faq-category-filter')) {
    customElements.define(
      'faq-category-filter',
      class FaqCategoryFilter extends HTMLElement {
        connectedCallback() {
          this.buttons = this.querySelectorAll('.faq-cat__category-btn');
          this.items = this.querySelectorAll('.accordion-item');
          this.buttons.forEach((btn) => btn.addEventListener('click', () => this.select(btn)));
        }

        select(activeBtn) {
          const category = activeBtn.dataset.category;
          this.buttons.forEach((btn) => {
            const isActive = btn === activeBtn;
            btn.classList.toggle('active', isActive);
            btn.setAttribute('aria-selected', isActive);
          });
          this.items.forEach((item) => {
            item.hidden = item.dataset.category !== category;
          });
        }
      }
    );
  }